(() => {
  const namespaceKey = 'GuruShopHeaderCartCountBadge';
  const markerSelector = 'script[data-header-cart-count-root]';
  const existingApi = window[namespaceKey];

  if (existingApi?.initById) {
    document.querySelectorAll(markerSelector).forEach((marker) => {
      existingApi.initById(marker.dataset.headerCartCountRoot);
    });
    return;
  }

  const initializedRoots = new WeakSet();
  const stateByRoot = new WeakMap();

  function initRoot(sectionRoot) {
    if (!sectionRoot || initializedRoots.has(sectionRoot)) return false;

    const badge = sectionRoot.querySelector('.header__cart-count-badge');
    const countElement = badge?.querySelector('cart-count');
    if (!badge || !countElement || badge.dataset.countBound === 'true') return false;

    const syncBadgeState = () => {
      const count = Number.parseInt((countElement.textContent || '0').replace(/[^\d]/g, ''), 10) || 0;
      badge.classList.toggle('is-hidden', count === 0);
    };

    const observer = new MutationObserver(syncBadgeState);
    observer.observe(countElement, {
      characterData: true,
      childList: true,
      subtree: true,
    });

    badge.dataset.countBound = 'true';
    initializedRoots.add(sectionRoot);
    stateByRoot.set(sectionRoot, { badge, observer });
    syncBadgeState();
    return true;
  }

  function cleanupRoot(sectionRoot) {
    if (!sectionRoot || !initializedRoots.has(sectionRoot)) return false;

    const state = stateByRoot.get(sectionRoot);
    state?.observer.disconnect();
    if (state?.badge) delete state.badge.dataset.countBound;
    stateByRoot.delete(sectionRoot);
    initializedRoots.delete(sectionRoot);
    return true;
  }

  function initById(sectionRootId) {
    if (!sectionRootId) return false;
    return initRoot(document.getElementById(sectionRootId));
  }

  document.addEventListener('shopify:section:load', (event) => initRoot(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanupRoot(event.target));

  const api = { cleanupRoot, initById, initRoot };
  window[namespaceKey] = api;

  document.querySelectorAll(markerSelector).forEach((marker) => {
    initById(marker.dataset.headerCartCountRoot);
  });
})();
